<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">{{ isEditMode ? $t('tslContractors.notes.edit') : $t('tslContractors.notes.add') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-textarea
            v-model="noteContent"
            :label="$t('tslContractors.notes.content')"
            :rules="[rules.required, rules.maxLength]"
            rows="5"
            counter="2000"
            maxlength="2000"
            outlined
            auto-grow
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="cancel"
        >
          {{ $t('tslContractors.notes.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!valid"
          @click="save"
        >
          {{ $t('tslContractors.notes.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'NoteDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    note: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      valid: false,
      noteContent: '',
      rules: {
        required: value => !!value || this.$t('tslContractors.notes.contentRequired'),
        maxLength: value => !value || value.length <= 2000 || this.$t('tslContractors.notes.contentMaxLength')
      }
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    isEditMode () {
      return this.note !== null && this.note !== undefined
    }
  },
  watch: {
    value (newVal) {
      if (newVal) {
        this.noteContent = this.note ? this.note.content : ''
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      }
    }
  },
  methods: {
    cancel () {
      this.noteContent = ''
      this.dialog = false
    },
    save () {
      if (this.$refs.form.validate()) {
        this.$emit('saved', {
          id: this.note ? this.note.id : null,
          content: this.noteContent
        })
        this.noteContent = ''
        this.dialog = false
      }
    }
  }
}
</script>
